import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import OutreachService from "../../src/Services/Outreach.service";
const OutreachLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        valueKey: "id",
        labelKey: "name",
        fetchItemsById: (ids) => {
            return OutreachService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return OutreachService.search({ query: search });
        },
        optionRenderer: function optionRenderer(outreach) {
            return _jsx("span", { children: outreach.name });
        },
    });
};
export default OutreachLookup;
